import React, { Component } from 'react';
import UserProfile from './UserProfile.js';
import UserTools from './UserTools.js';
import update from 'immutability-helper';
import './ConnectedUsers.css';

export default class extends Component {
  constructor(props) {
    super(props);
    this.updateUser = this.updateUser.bind(this);
  }

  canEditUser(user) {
    let userMatch = false;
    let currentUser = this.props.currentUser;
    if (currentUser)
      if (user.uid === currentUser.uid)
        userMatch = true;
    return userMatch;
  }

  updateUser(user) {
    if (this.canEditUser(user)) {
      let usersRef = this.props.roomRef.collection('users');
      let cleanUser = update(user, {$unset: ['id']});
      usersRef.doc(user.id).update(cleanUser).catch(function(error) {
        console.error("Error updating document: ", error);
      });
    } else {
      console.error("You cannot edit this user");
    }
  }

  renderUserProfile(user, index) {
    return (
      <UserProfile
        key={index}
        user={user}
        canEdit={this.canEditUser(user)}
        roomCurrentStepType={this.props.roomCurrentStepType}
        roomShowEstimate={this.props.roomShowEstimate}
        updateUser={this.updateUser} />
    );
  }

  render() {
    let userTools = (!this.props.showJoinRoomPrompt && this.props.currentUser) ?
      <UserTools
        currentUser={this.props.currentUser}
        roomCurrentStepType={this.props.roomCurrentStepType}
        roomLastUserReady={this.props.roomLastUserReady}
        roomShowEstimate={this.props.roomShowEstimate}
        roomShowTotalEstimate={this.props.roomShowTotalEstimate}
        updateUser={this.updateUser} /> : null;

    return (
      <div className="connected-users">
        <div className="connected-users-content">
          {this.props.users.map((user, index) => this.renderUserProfile(user, index))}
        </div>
        {userTools}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Room/ConnectedUsers.js